import ServerConstants from './server.js';
import server from '@/server/request.js';
import {tpl_url} from "@/utils/common";
/**
 * 获取用户团队列表
 * @param success 
 * @param errorfun 
 * @returns 
 */
export function getUserTeamList( success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(ServerConstants.API_GET_USER_TEAM_LIST, {}, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 获取最后一次打开的团队详情
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getLastTeamDetail(data = {}, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(ServerConstants.API_GET_LAST_TEAM_DETAIL, data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 创建团队
 * @param {*} data 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function createTeam(data, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.postJSON(ServerConstants.API_CREATE_TEAM, data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 退出团队
 * @param {*} teamId 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function leaveTeam(teamId, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.deleteJSON(tpl_url(ServerConstants.API_DELETE_TEAM_BY_TEAMID, teamId), function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 更新团队信息
 * @param {*} data 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function updateTeam(data, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.postJSON(ServerConstants.API_POST_UPDATE_TEAM, data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 获取团队成员列表
 * @param {*} teamId 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getTeamMembers(teamId, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(tpl_url(ServerConstants.API_GET_TEAM_MEMBERS, teamId), {}, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 移除团队成员
 * @param {*} teamId 
 * @param {*} memberId 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function removeTeamMember(teamId, memberId, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.deleteJSON(tpl_url(ServerConstants.API_DELETE_TEAM_MEMBER, teamId), memberId, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 获取数据字典
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getBaseDict(success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(ServerConstants.API_GET_BASE_DICT, {}, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 更新用户信息
 * @param {*} teamId 团队id
 * @param {*} data 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function updateUserInfo(teamId, data, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.postJSON(tpl_url(ServerConstants.API_POST_UPDATE_USER_INFO, teamId), data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 邀请新成员
 * @param {*} teamId 
 * @param {*} data 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function inviteNewMember(teamId, data, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.postJSON(tpl_url(ServerConstants.API_POST_INVITE_MEMBER, teamId), data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 接受邀请
 * @param {*} invitationId 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getAcceptedInvitation(invitationId, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.putJSON(tpl_url(ServerConstants.API_PUT_ACCEPTED_INVITATION, invitationId), function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 获取邀请详情
 * @param {*} invitationId 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getInvitationDetail(invitationId, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(tpl_url(ServerConstants.API_GET_INVITATION_DETAIL, invitationId), {}, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 查询团队存储统计信息
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getTeamStorage(success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(ServerConstants.API_GET_TEAM_STORAGE, {}, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 获取团队日志信息
 * @param {*} teamId 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function getTeamDataLog(teamId, params = {}, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.getJSON(tpl_url(ServerConstants.API_GET_TEAM_DATA_LOG, teamId), params, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 移交团队管理员
 * @param {*} teamId 
 * @param {*} data { memberId: '' }
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function transferTeamAdmin(teamId, data, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.postJSON(tpl_url(ServerConstants.API_POST_TRANSFER_TEAM, teamId), data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}

/**
 * 合并团队
 * @param {*} data 
 * @param {*} success 
 * @param {*} errorfun 
 * @returns 
 */
export function mergeTeam(data, success, errorfun) {
    return new Promise((resolve, reject) => {
        server.putJSON(ServerConstants.API_PUT_MERGE_TEAM, data, function(response) {
            resolve(response.data);
            server.call(success, response);
        }, function(error) {
            server.call(errorfun, error);
            reject(error);
        });
    });
}
